import React, { Component } from 'react';
import EffectParameterSlider from './EffectParameterSlider.js';
import RackComponent from './rack/RackComponent.js';

class EffectRackComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            effect: props.effect,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.state.effect = nextProps.effect;
        return true;
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.state.effect.isEnabled();
    }

    render() {
        let compressor = this.state.effect.compressorNode;
        let gainNode = this.state.effect.effectNode;
        let className = this.props.automation !== undefined ?
            'enabled tall-effect effect effect-automation' :
            this.state.effect.isEnabled() ? 'tall-effect effect enabled' :
            'effect disabled';
        return (
            <div>
              {!this.isEnabled() ? '' :
                <div>
                      <RackComponent
                        isDraggable={this.props.isDraggable}
                        track={this.props.track}
                        scrollContainer={this.props.scrollContainer}
                        send={this.props.send}
                        compact={this.props.compact}
                        sequencerEngine={this.props.sequencerEngine}
                        effect={this.state.effect}/>
                </div>
                }
            </div>
        );
    }
}

export default EffectRackComponent;
